import { Grid, Link, Typography } from '@material-ui/core';
import React, { VFC } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { REACT_APP_MONOLITH_BASE_URL } from 'runtimeEnvVars';

import GlobalNav from 'components/GlobalNav';
import LeftArrow from 'images/arrow-left.svg';

import { messages } from './messages';
import { OAuth2ConfigurationForm } from './OAuth2ConfigurationForm';
import { useStyles } from './styles';

export const OAuth2Configuration: VFC = () => {
  const intl = useIntl();
  const styles = useStyles();
  const pageTitle = intl.formatMessage(messages.pageTitle);
  const { accountSlug } = useParams<{ accountSlug: string }>();

  const toBackLink = (): string => {
    return `${REACT_APP_MONOLITH_BASE_URL}/${accountSlug}/webhooks/settings`;
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <Grid container direction="column">
        <GlobalNav />
        <Grid container direction="column" className={styles.container}>
          <Grid item className={styles.backToSettings}>
            <Link href={toBackLink()}>
              <img
                src={LeftArrow}
                alt="back arrow"
                className={styles.leftArrow}
              />
              <FormattedMessage {...messages.back} />
            </Link>
          </Grid>
          <Typography variant="h2">{pageTitle}</Typography>
          <Typography
            variant="body2"
            color="textPrimary"
            className={styles.subtitle}
          >
            {intl.formatMessage(messages.pageDescription)}
          </Typography>
          <OAuth2ConfigurationForm />
        </Grid>
      </Grid>
    </>
  );
};
